import { ICategoryService } from './ICategoryService';
import { Category } from '@/types';
import { categories } from '@/mocks/categories/mvp';

export class MockedCategoryService implements ICategoryService {
    public async getCategories(): Promise<Category[]> {
        return categories;
    }
}
